module.exports = ".tituloHijo {\r\n    padding-left: 1.9em !important;\r\n}"